import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BasePagingResponse } from "../_types";

export type GetMerchantListRequest = {
  page?: number;
  size?: number;
  orderByDesc?: boolean;
  orderBy?: string;
  merchantId?: string | number;
  systemDateStart?: string;
  systemDateEnd?: string;
  lastTransactionBankBlocked?: boolean;
  [key: string]: string | number | boolean | undefined;
};

export type IMerchant = {
  id?: number;
  merchantId?: number;
  memberId?: number;
  merchantType: number;
  merchantStatusType: string;
  merchantName: string;
  parentMerchantId: number;
  tradeName: string;
  tradeRegistrationNumber: string;
  commissionProfileCode: string;
  webSite: string;
  taxNumber: string;
  taxOfficeCode: string;
  taxOfficeName: string;
  citizenshipNumber: string;
  mcc: string;
  originalMcc?: string;
  foundationDate: string;
  openingDate: string;
  aggreementDate: string;
  closedDate: null | string;
  phoneNumber: string;
  description: string;
  mobilePos: boolean;
  cepPos: boolean;
  vpos: boolean;
  pos: boolean;
  try: boolean;
  usd: boolean;
  eur: boolean;
  officialFullName: string;
  officialCitizenNumber?: string;
  officialMobilePhone?: string;
  officialBirthDate?: string | null;

  partnerOneFullName?: string;
  partnerOneCitizenNumber?: string;
  partnerOneMobilePhone?: string;
  partnerOneBirthDate?: string | null;
  partnerOnePercent?: number;
  partnerOneType?: string;

  partnerTwoFullName?: string;
  partnerTwoCitizenNumber?: string;
  partnerTwoMobilePhone?: string;
  partnerTwoBirthDate?: string | null;
  partnerTwoPercent?: number;
  partnerTwoType?: string;

  partnerThreeFullName?: string;
  partnerThreeCitizenNumber?: string;
  partnerThreeMobilePhone?: string;
  partnerThreeBirthDate?: string | null;
  partnerThreePercent?: number;
  partnerThreeType?: string;

  partnerFourFullName?: string;
  partnerFourCitizenNumber?: string;
  partnerFourMobilePhone?: string;
  partnerFourBirthDate?: string | null;
  partnerFourPercent?: number;
  partnerFourType?: string;

  partnerFiveFullName?: string;
  partnerFiveCitizenNumber?: string;
  partnerFiveMobilePhone?: string;
  partnerFiveBirthDate?: string | null;
  partnerFivePercent?: number;
  partnerFiveType?: string;

  addressLine1: string;
  iban: string;
  isPaymentDescriptionActive: boolean;
  taxOfficeCityCode: string;
  employeeCount?: number;
  estimatedGiro?: number;
  isUsageFee?: boolean;
  lastTransactionBankBlocked?: boolean;
  lastBankBlockedDate?: string;
};

export type GetMerchantListResponse = BasePagingResponse<Array<any>>;

// async function getMerchantList({
//   page = 0,
//   size = 15,
//   orderByDesc = true,
//   orderBy = "CreateDate",
//   merchantId
// }: GetMerchantListRequest): Promise<any> {
//   const data = {
//     page,
//     size,
//     orderByDesc,
//     orderBy,
//     merchantId
//   };
//   try {
//     return (await axiosInstance.post("/Merchant/List", data)).data;
//   } catch (ex) {
//     throw ((ex as AxiosError).response?.data as any).error;
//   }
// }

async function getMerchantList(
  data: GetMerchantListRequest
): Promise<any> {
  try {
    return (await axiosInstance.post("/Merchant/List", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantList() {
  return useMutation<GetMerchantListResponse, Error, GetMerchantListRequest>(
    (variables) => getMerchantList(variables)
  );
}
